import { render } from "./PerformanceAppraisalDetails.vue?vue&type=template&id=2f455b51&scoped=true"
import script from "./PerformanceAppraisalDetails.vue?vue&type=script&lang=js"
export * from "./PerformanceAppraisalDetails.vue?vue&type=script&lang=js"

import "./PerformanceAppraisalDetails.vue?vue&type=style&index=0&id=2f455b51&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/DBCapacity-VUE/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f455b51"]])

export default __exports__